import addAriaLiveLabel from '../actions/addAriaLiveLabel';
import cx from 'classnames/bind';
import React, { memo } from 'react';
import styles from './AccessibilityAnchorButton.scss';
import { mergeStyles } from '@uifabric/merge-styles';
import type { AccessibilityAnchorButtonProps } from '../schema/AccessibilityAnchorButtonProps';
import { AccessibilityAnchorOrientation } from '../schema/AccessibilityAnchorButtonProps';

const classNames = cx.bind(styles);

const getStyleFromOrientationAndIndex = (
    orientation: AccessibilityAnchorOrientation,
    orientationIndex: number
) => {
    const distance: string = `${orientationIndex * 2}px`;
    switch (orientation) {
        case AccessibilityAnchorOrientation.Top:
            return {
                top: distance,
                left: 0,
            };
        case AccessibilityAnchorOrientation.Right:
            return {
                right: distance,
                top: 0,
            };
        case AccessibilityAnchorOrientation.Left:
            return {
                left: distance,
                top: 0,
            };
        case AccessibilityAnchorOrientation.Bottom:
        default:
            return {
                bottom: distance,
                left: 0,
            };
    }
};

/**
 * Renders an invisible button to let help screen reader users close popup dialogs
 */
const AccessibilityAnchorButton = React.forwardRef(
    (
        {
            label,
            onClick,
            backgroundColor,
            announcementOnClick,
            orientation,
            orientationIndex,
        }: AccessibilityAnchorButtonProps,
        /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
         * See aka.ms/mini-lint-errors
         *	> Unexpected any. Specify a different type. */
        ref?: React.RefObject<any>
    ): JSX.Element => (
        <button
            ref={ref}
            tabIndex={0}
            aria-label={label}
            onClick={
                announcementOnClick
                    ? /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
                       * See aka.ms/mini-lint-errors
                       *	> Unexpected any. Specify a different type. */
                      (ev?: React.MouseEvent<any>) => {
                          onClick(ev);
                          addAriaLiveLabel(announcementOnClick);
                      }
                    : onClick
            }
            className={classNames(
                styles.anchorButton,
                backgroundColor
                    ? mergeStyles({ backgroundColor: `${backgroundColor} !important` })
                    : null,
                mergeStyles(getStyleFromOrientationAndIndex(orientation, orientationIndex))
            )}
        />
    )
);

AccessibilityAnchorButton.defaultProps = {
    key: 'accessibilityAnchorButton',
    orientation: AccessibilityAnchorOrientation.Bottom,
    orientationIndex: 0,
};

export default memo(AccessibilityAnchorButton);
